export const toys = [
  {
    id: 41,
    title: "Mini Animal Toy Set Pack",
    image: "https://minnaminnie.vercel.app/images/t1animal-removebg-preview.png",
    price: 1299,
    discountPrice: 899,
    sale: true,
  },
  {
    id: 42,
    title: "Colorful Advanced Racing-Cars",
    image: "https://minnaminnie.vercel.app/images/t5racingcar.webp",
    price: 1699,
    discountPrice: 1199,
    sale: false,
  },
  {
    id: 43,
    title: "Mini Ducks Toy Set Brown",
    image: "https://minnaminnie.vercel.app/images/t3duck__2_-removebg-preview.png",
    price: 1499,
    discountPrice: 999,
    sale: true,
  },
  {
    id: 44,
    title: "Mini Teddy Bear Soft Set",
    image: "https://minnaminnie.vercel.app/images/t4teadtbear1-removebg-preview.png",
    price: 899,
    discountPrice: 699,
    sale: false,
  },
  {
    id: 45,
    title: "Educational Wooden Puzzle Board",
    image: "https://minnaminnie.vercel.app/images/t5boxes.png",
    price: 1199,
    discountPrice: 799,
    sale: true,
  },
  {
    id: 46,
    title: "Baby Tractor Toy Vehicle Set",
    image: "https://minnaminnie.vercel.app/images/t6tractor-removebg-preview.png",
    price: 599,
    discountPrice: 499,
    sale: false,
  },
];
export const shoes = [
  {
    id: 31,
    title: "Boys Sneakers Casual - Navy Blue",
    image: "https://minnaminnie.vercel.app/images/shoe1-removebg-preview.png",
    price: 2599,
    discountPrice: 2099,
    sale: true,
  },
  {
    id: 32,
    title: "Girls Glitter Pumps - Pink Shine",
    image: "https://minnaminnie.vercel.app/images/shoe2-removebg-preview.png",
    price: 2399,
    discountPrice: 1899,
    sale: true,
  },
  {
    id: 33,
    title: "Unisex Slip-on Shoes - Grey Sport",
    image: "https://minnaminnie.vercel.app/images/shoe3-removebg-preview.png",
    price: 1999,
    discountPrice: 1599,
    sale: false,
  },
  {
    id: 34,
    title: "Kids Velcro Sandals - Black Edition",
    image: "https://minnaminnie.vercel.app/images/shoe4-removebg-preview.png",
    price: 1399,
    discountPrice: 1199,
    sale: false,
  },
  {
    id: 35,
    title: "Girls Ballerina Flats - Purple Charm",
    image: "https://minnaminnie.vercel.app/images/shoe5-removebg-preview.png",
    price: 2199,
    discountPrice: 1799,
    sale: true,
  },
  {
    id: 36,
    title: "Kids Canvas Shoes - Multicolor Pack",
    image: "https://minnaminnie.vercel.app/images/shoe6-removebg-preview.png",
    price: 1899,
    discountPrice: 1499,
    sale: false,
  },
];

// products.js

export const sportswear = [
  {
    id: 11,
    title: "Boys Athletic Tracksuit Set - Navy",
    image: "https://minnaminnie.vercel.app/images/sp1-removebg-preview.png",
    price: 2499,
    discountPrice: 1999,
    sale: true,
  },
  {
    id: 12,
    title: "Girls Activewear Outfit Set - Peach",
    image: "https://minnaminnie.vercel.app/images/sp2-removebg-preview.png",
    price: 2299,
    discountPrice: 1799,
    sale: true,
  },
  {
    id: 13,
    title: "Unisex Kids Joggers Set - Grey",
    image: "https://minnaminnie.vercel.app/images/sp3-removebg-preview.png",
    price: 1799,
    discountPrice: 1499,
    sale: false,
  },
  {
    id: 14,
    title: "Boys Sleeveless Tank Top - Blue",
    image: "https://minnaminnie.vercel.app/images/sp4-removebg-preview.png",
    price: 899,
    discountPrice: 749,
    sale: false,
  },
  {
    id: 15,
    title: "Girls Yoga Outfit Set - Purple",
    image: "https://minnaminnie.vercel.app/images/sp5-removebg-preview.png",
    price: 1999,
    discountPrice: 1599,
    sale: true,
  },
  {
    id: 16,
    title: "Kids Sports T-Shirt Pack - Multicolor",
    image: "https://minnaminnie.vercel.app/images/sp6-removebg-preview.png",
    price: 1299,
    discountPrice: 1099,
    sale: false,
  },
];



// products.js
export const garments = [
  {
    id: "product1",
    title: "Baby Outfit 1",
    price: 1200,
    image: "https://minnaminnie.vercel.app/images/p11.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p12.jpg",
    sizes: ["1-2", "2-3", "3-4"],
    features: [
      "100% cotton material",
      "Comfortable and stylish",
      "Perfect for summer days",
      "Soft fabric with cute pattern",
    ],
  },
  {
    id: "product2",
    title: "Baby Outfit 2",
    price: 1250,
    image: "https://minnaminnie.vercel.app/images/p21.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p22.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Breathable cotton blend",
      "Easy front button style",
      "Casual and comfortable",
    ],
  },
  {
    id: "product3",
    title: "Baby Outfit 3",
    price: 1300,
    image: "https://minnaminnie.vercel.app/images/p31.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p32.jpg",
    sizes: ["3-4", "4-5", "5-6"],
    features: [
      "Classic striped design",
      "Lightweight and airy",
      "Fashion-forward look for kids",
    ],
  },
  {
    id: "product4",
    title: "Baby Outfit 4",
    price: 1350,
    image: "https://minnaminnie.vercel.app/images/p41.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p42.jpg",
    sizes: ["4-5", "5-6", "6-7"],
    features: [
      "Vibrant color palette",
      "Made for active toddlers",
      "Easy care fabric",
    ],
  },
  {
    id: "product5",
    title: "Baby Outfit 5",
    price: 1400,
    image: "https://minnaminnie.vercel.app/images/p51.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p52.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Cotton comfort",
      "Attractive pattern",
      "Soft neckline and sleeves",
    ],
  },
  {
    id: "product6",
    title: "Baby Outfit 6",
    price: 1450,
    image: "https://minnaminnie.vercel.app/images/p61.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p62.jpg",
    sizes: ["1-2", "2-3"],
    features: [
      "Ideal for infants",
      "Adorable cartoon print",
      "Gentle on baby skin",
    ],
  },
  {
    id: "product7",
    title: "Baby Outfit 7",
    price: 1500,
    image: "https://minnaminnie.vercel.app/images/p71.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p73.jpg",
    sizes: ["3-4", "4-5"],
    features: [
      "Unique pattern style",
      "Durable quality",
      "Day-out ready fashion",
    ],
  },
  {
    id: "product8",
    title: "Baby Outfit 8",
    price: 1550,
    image: "https://minnaminnie.vercel.app/images/p81.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p82.jpg",
    sizes: ["1-2", "2-3", "3-4"],
    features: [
      "Colorful and playful",
      "Relaxed fit",
      "Machine washable fabric",
    ],
  },
  {
    id: "product9",
    title: "Baby Outfit 9",
    price: 1600,
    image: "https://minnaminnie.vercel.app/images/p91.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p92.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Denim-inspired look",
      "Chic and breathable",
      "Easy snap buttons",
    ],
  },
  {
    id: "product10",
    title: "Baby Outfit 10",
    price: 1650,
    image: "https://minnaminnie.vercel.app/images/p101.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p102.jpg",
    sizes: ["4-5", "5-6"],
    features: [
      "Half-sleeve summer style",
      "Trendy printed fabric",
      "Soft inner lining",
    ],
  },
  {
    id: "product11",
    title: "Baby Outfit 11",
    price: 1700,
    image: "https://minnaminnie.vercel.app/images/p111.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p112.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Peach pastel tone",
      "Light and fresh design",
      "Cotton-blend comfort",
    ],
  },
  {
    id: "product12",
    title: "Baby Outfit 12",
    price: 1750,
    image: "https://minnaminnie.vercel.app/images/p121.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p122.jpg",
    sizes: ["1-2", "2-3"],
    features: [
      "Soft polo neck design",
      "Relax fit for summer",
      "Sky blue classic vibe",
    ],
  },
  {
    id: "product13",
    title: "Baby Outfit 13",
    price: 1800,
    image: "https://minnaminnie.vercel.app/images/p131.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p134.jpg",
    sizes: ["3-4", "4-5", "5-6"],
    features: [
      "Fun and trendy print",
      "Perfect for toddlers",
      "All-day comfort wear",
    ],
  },
  // ... (rest of the products up to product13)
];


export const girlsapparel=[
  {
    id: "product1",
    title: "Baby Outfit 1",
    price: 1200,
    image: "https://minnaminnie.vercel.app/images/p11.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p12.jpg",
    sizes: ["1-2", "2-3", "3-4"],
    features: [
      "100% cotton material",
      "Comfortable and stylish",
      "Perfect for summer days",
      "Soft fabric with cute pattern",
    ],
  },
  {
    id: "product4",
    title: "Baby Outfit 4",
    price: 1350,
    image: "https://minnaminnie.vercel.app/images/p41.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p42.jpg",
    sizes: ["4-5", "5-6", "6-7"],
    features: [
      "Vibrant color palette",
      "Made for active toddlers",
      "Easy care fabric",
    ],
  },
  {
    id: "product9",
    title: "Baby Outfit 9",
    price: 1600,
    image: "https://minnaminnie.vercel.app/images/p91.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p92.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Denim-inspired look",
      "Chic and breathable",
      "Easy snap buttons",
    ],
  },
  {
    id: "product13",
    title: "Baby Outfit 13",
    price: 1800,
    image: "https://minnaminnie.vercel.app/images/p131.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p134.jpg",
    sizes: ["3-4", "4-5", "5-6"],
    features: [
      "Fun and trendy print",
      "Perfect for toddlers",
      "All-day comfort wear",
    ],
  },

]
export const boyspparel=[
  {
    id: "product2",
    title: "Baby Outfit 2",
    price: 1250,
    image: "https://minnaminnie.vercel.app/images/p21.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p22.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Breathable cotton blend",
      "Easy front button style",
      "Casual and comfortable",
    ],
  },
  {
    id: "product3",
    title: "Baby Outfit 3",
    price: 1300,
    image: "https://minnaminnie.vercel.app/images/p31.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p32.jpg",
    sizes: ["3-4", "4-5", "5-6"],
    features: [
      "Classic striped design",
      "Lightweight and airy",
      "Fashion-forward look for kids",
    ],
  },
  {
    id: "product5",
    title: "Baby Outfit 5",
    price: 1400,
    image: "https://minnaminnie.vercel.app/images/p51.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p52.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Cotton comfort",
      "Attractive pattern",
      "Soft neckline and sleeves",
    ],
  },
  {
    id: "product6",
    title: "Baby Outfit 6",
    price: 1450,
    image: "https://minnaminnie.vercel.app/images/p61.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p62.jpg",
    sizes: ["1-2", "2-3"],
    features: [
      "Ideal for infants",
      "Adorable cartoon print",
      "Gentle on baby skin",
    ],
  },
  {
    id: "product7",
    title: "Baby Outfit 7",
    price: 1500,
    image: "https://minnaminnie.vercel.app/images/p71.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p73.jpg",
    sizes: ["3-4", "4-5"],
    features: [
      "Unique pattern style",
      "Durable quality",
      "Day-out ready fashion",
    ],
  },
  {
    id: "product8",
    title: "Baby Outfit 8",
    price: 1550,
    image: "https://minnaminnie.vercel.app/images/p81.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p82.jpg",
    sizes: ["1-2", "2-3", "3-4"],
    features: [
      "Colorful and playful",
      "Relaxed fit",
      "Machine washable fabric",
    ],
  },
  {
    id: "product10",
    title: "Baby Outfit 10",
    price: 1650,
    image: "https://minnaminnie.vercel.app/images/p101.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p102.jpg",
    sizes: ["4-5", "5-6"],
    features: [
      "Half-sleeve summer style",
      "Trendy printed fabric",
      "Soft inner lining",
    ],
  },
  {
    id: "product11",
    title: "Baby Outfit 11",
    price: 1700,
    image: "https://minnaminnie.vercel.app/images/p111.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p112.jpg",
    sizes: ["2-3", "3-4", "4-5"],
    features: [
      "Peach pastel tone",
      "Light and fresh design",
      "Cotton-blend comfort",
    ],
  },
  {
    id: "product12",
    title: "Baby Outfit 12",
    price: 1750,
    image: "https://minnaminnie.vercel.app/images/p121.jpg",
    hoverImage: "https://minnaminnie.vercel.app/images/p122.jpg",
    sizes: ["1-2", "2-3"],
    features: [
      "Soft polo neck design",
      "Relax fit for summer",
      "Sky blue classic vibe",
    ],
  }
]
